import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import AssistantFileUpload from './AssistantFileUpload.js';

import Box from '@mui/material/Box';
import '../dashboard/Dashboard.css';
import Button from '@mui/material/Button';
import axios from 'axios';
import Loader from "../util/Loader";
import TextField from '@mui/material/TextField';
import { DataGrid } from '@mui/x-data-grid';
import Modal from '@mui/material/Modal';
import Alert from '@mui/material/Alert';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';

import call_openai from 'openai/Assistant';

const baseApiUri = process.env.REACT_APP_API_URL;

const modalstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const containerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  width: '100%',
  height: '100%',
  padding: '20px',
};

const columnStyle = {
  flex: '2',
  padding: '10px',
  boxSizing: 'border-box',
};

let initialValues = {
  description: "",
  name: "",
  instructions: "",
  sandboxname: "",
  question: "",
  response: ""
};

export default function AssistantAdmin() {
  const [loading, setLoading] = useState(false);
  const [showSandbox, setShowSandbox] = useState(false);
  const [assistant, setAssistant] = useState({});
  const { id, sandbox } = useParams();
  const [values, setValues] = useState(initialValues);
  const [rows, setRows] = useState([]);
  const [documentRows, setDocumentRows] = useState([]);
  const [sandboxrows, setSandboxows] = useState([]);
  const [open, setOpen] = useState(false);
  const [chatResponse, setChatResponse] = useState();
  const [isSandbox, setIsSandbox] = useState(false);
  const [showPublishButton, setShowPublishButton] = useState(true);

  const navigate = useNavigate();

  let columns = [
    { field: 'id', headerName: 'ID', flex: 1 },
    { field: 'name', headerName: 'Name', flex: 3, editable: true },
    {
      field: 'edit',
      headerName: '',
      renderCell: ({ row }) => (
        <strong>
          <EditOutlinedIcon className="App-icon-spacing App-icon-cursor" onClick={() => navigate(`/assistantfunctionadmin/${assistant.id}/${row.id}`)} />
        </strong>
      ),
    }
  ];

  let documentColumns = [
    { field: 'id', headerName: 'ID', flex: 1 },
    { field: 'key', headerName: 'Name', flex: 3, editable: true },
    {
      field: 'edit',
      headerName: '',
      renderCell: ({ row }) => (
        <strong>
          <EditOutlinedIcon className="App-icon-spacing App-icon-cursor" onClick={() => navigate(`/assistantfunctionadmin/${assistant.id}/${row.id}`)} />
        </strong>
      ),
    }
  ];

  let sandboxcolumns = [
    { field: 'id', headerName: 'ID', flex: 1 },
    { field: 'sandbox', headerName: 'Name', flex: 3, editable: true },
    {
      field: 'edit',
      headerName: '',
      renderCell: ({ row }) => (
        <strong>
          <ArrowCircleRightIcon className="App-icon-spacing App-icon-cursor" onClick={() => navigate(`/assistantadmin/${row.id}`)} />
        </strong>
      ),
    }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const cancel = () => navigate(`/assistantsadmin`);
  const handleClose = () => setOpen(false);

  const createSandbox = async () => {
    try {
      const payload = { sandbox: values.sandboxname };
      const endpoint = `${baseApiUri}/ai/assistant/${id}/clone?key=09848734-8745-afrt-8745-8745873487`;
      const res = await axios.post(endpoint, payload);
      const sandboxId = res.data.assistantId;
      setShowSandbox(false);
      navigate(`/assistantadmin/${sandboxId}`);
    } catch (e) {
      console.log(e);
    }
  };

  const saveAssistant = async () => {
    try {
      const payload = { ...assistant, name: values.name };
      payload.definition.description = values.description;
      payload.definition.instructions = values.instructions;
      const endpoint = `${baseApiUri}/ai/assistant/${id}?key=09848734-8745-afrt-8745-8745873487`;
      await axios.put(endpoint, payload);
    } catch (e) {
      console.log(e);
    }
  };

  const testAssistant = () => setOpen(true);

  /** ✅ Publish Assistant */
  const publishAssistant = async () => {
    try {
      const endpoint = `${baseApiUri}/ai/assistant/${id}/publish?key=09848734-8745-afrt-8745-8745873487`;
      await axios.post(endpoint);
      setShowPublishButton(false); // hide button on success
    } catch (e) {
      console.error('Error publishing assistant:', e);
    }
  };

  useEffect(() => {
    async function loadSandboxes() {
      try {
        const endpoint = `${baseApiUri}/ai/assistant?key=09848734-8745-afrt-8745-8745873487`;
        const res = await axios.get(endpoint);
        const rows = res.data.assistants.filter(a => a.hasOwnProperty('sandbox'));
        setSandboxows(rows);
      } catch (e) {
        console.log(e);
      }
    }

    async function loadAssistant() {
      setLoading(true);
      try {
        const endpoint = `${baseApiUri}/ai/assistant/${id}?key=09848734-8745-afrt-8745-8745873487`;
        const res = await axios.get(endpoint);
        const currentAssistant = res.data.assistant;
        setAssistant(currentAssistant);

        const newvalues = {
          name: currentAssistant.name,
          description: currentAssistant.definition.description,
          instructions: currentAssistant.definition.instructions,
          sandboxname: '',
          question: '',
          response: ''
        };
        setValues(newvalues);
        if (currentAssistant.hasOwnProperty('sandbox')) setIsSandbox(true);

        // load documents
        const endpointD = `${baseApiUri}/ai/document?key=09848734-8745-afrt-8745-8745873487`;
        const resD = await axios.get(endpointD);
        const documents = resD.data.documents.map(d => ({ ...d, id: d.identifier }));
        setDocumentRows(documents);

        // load functions
        const endpointF = `${baseApiUri}/ai/assistant/${id}/function/?key=09848734-8745-afrt-8745-8745873487`;
        const resF = await axios.get(endpointF);
        const functions = resF.data.functions.map(f => ({ ...f, id: f.functionId }));
        setRows(functions);
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    }

    if (sandbox === 'sandbox') setShowSandbox(true);
    else setShowSandbox(false);

    loadAssistant();
    loadSandboxes();
  }, [id, sandbox]);

  return (
    <div style={{ textAlign: "left" }}>
      <Loader open={loading} />

      {showSandbox ? (
        <>
          {/* Sandbox View */}
          <div><h1>Create or select a sandbox</h1></div>
          <div style={containerStyle}>
            {/* Left column: create new sandbox */}
            <div style={columnStyle}>
              <h2>Create New Sandbox</h2>
              <TextField id="sandboxname" label="Sandbox Name" variant="outlined"
                value={values.sandboxname} name="sandboxname" onChange={handleInputChange} className="App-textarea" />
              <Button sx={{ mt: 2 }} variant="contained" onClick={createSandbox}>Create Sandbox</Button>
            </div>

            {/* Right column: select existing sandbox */}
            <div style={columnStyle}>
              <h2>Select an Existing Sandbox</h2>
              <Box sx={{ height: 500, width: '100%', backgroundColor: '#ffffff' }}>
                <DataGrid rows={sandboxrows} columns={sandboxcolumns} pageSizeOptions={[5]} checkboxSelection disableRowSelectionOnClick />
              </Box>
            </div>
          </div>
        </>
      ) : (
        <Box sx={{ padding: '20px' }}>
          {isSandbox && <Alert severity="warning">You are currently working in a sandbox Assistant</Alert>}

          <h1>Manage Assistant</h1>
          <div style={containerStyle}>
            {/* Left column */}
            <div style={columnStyle}>
              <h2>Assistant Details: {assistant.name}</h2>
              <TextField id="name" label="Name" variant="outlined" value={values.name} name="name" onChange={handleInputChange} fullWidth sx={{ mb: 2 }} />
              <TextField id="description" label="Description" multiline rows={10} variant="outlined" value={values.description} name="description" onChange={handleInputChange} fullWidth sx={{ mb: 2 }} />
              <TextField id="instructions" label="Instructions" multiline rows={50} variant="outlined" value={values.instructions} name="instructions" onChange={handleInputChange} fullWidth />
            </div>

            {/* Right column */}
            <div style={columnStyle}>
              {/* ✅ New Publish Assistant button */}
              {showPublishButton && (
                <Button sx={{ mr: 1, mb: 1 }} variant="contained" color="secondary" onClick={publishAssistant}>
                  Publish Assistant
                </Button>
              )}
              <Button sx={{ mr: 1, mb: 1 }} variant="contained" onClick={testAssistant}>Test Assistant</Button>
              <Button sx={{ mr: 1, mb: 1 }} variant="contained" onClick={saveAssistant}>Save Assistant</Button>
              <Button sx={{ mr: 1, mb: 1 }} variant="contained" onClick={cancel}>Cancel</Button>

              <h2>Assistant Functions</h2>
              <Box sx={{ height: 500, width: '100%', backgroundColor: '#ffffff' }}>
                <DataGrid rows={rows} columns={columns} pageSizeOptions={[5]} checkboxSelection disableRowSelectionOnClick />
              </Box>

              <h2>Assistant Files
                <Button sx={{ ml: 2 }} variant="contained" onClick={() => document.getElementById("hiddenFileInput").click()}>+ Upload File</Button>
                <AssistantFileUpload assistant={assistant} />
              </h2>

              <Box sx={{ height: 500, width: '100%', backgroundColor: '#ffffff' }}>
                <DataGrid rows={documentRows} columns={documentColumns} pageSizeOptions={[5]} checkboxSelection disableRowSelectionOnClick />
              </Box>
            </div>
          </div>

          {/* Test Assistant Modal */}
          <Modal open={open} onClose={handleClose}>
            <Box sx={modalstyle}>
              <h3>Test Assistant</h3>
              <Button sx={{ mr: 1 }} variant="contained" onClick={() => call_openai(setChatResponse, values.question, isSandbox, assistant.sandbox)}>Ask</Button>
              <Button sx={{ mr: 1 }} variant="contained" onClick={handleClose}>Close</Button>
              <TextField id="question" label="Assistant Question" variant="outlined" value={values.question} name="question" onChange={handleInputChange} fullWidth sx={{ mt: 2 }} />
              <div dangerouslySetInnerHTML={{ __html: chatResponse }} style={{ marginTop: '10px' }} />
            </Box>
          </Modal>
        </Box>
      )}
    </div>
  );
}
